import "./LegalModal.css";

function LegalModal({
  open,
  title,
  content,
  onClose,
}) {

  if (!open) return null;

  return (
    <div className="legal-overlay">

      <div className="legal-modal">

        <div className="legal-header">

          <h2>{title}</h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ✕
          </button>

        </div>

        <div className="legal-body">

          {content}

        </div>

      </div>

    </div>
  );
}

export default LegalModal;